/**
 * Делает горизонтально прокручивающиеся таблицы доступными с клавиатуры.
 *
 * Ниже 768px (см. правило `table` в style.scss) широкие таблицы получают
 * overflow-x: auto и скроллятся сами, а не раздвигают страницу. Но без
 * фокусируемых элементов внутри такую таблицу нельзя проскроллить с
 * клавиатуры — добавляем tabindex и роль только тем таблицам, которые
 * реально переполнены, и снимаем их, если переполнение исчезло
 * (например, страница вышла из zoom).
 */

const TABLE_SELECTOR = "table";

function isOverflowing(table) {
  return table.scrollWidth > table.clientWidth + 1;
}

function syncTable(table) {
  if (isOverflowing(table)) {
    if (!table.hasAttribute("tabindex")) {
      table.setAttribute("tabindex", "0");
      table.setAttribute("role", "region");
      table.setAttribute("aria-label", "Таблица, прокручивается по горизонтали");
    }
  } else {
    table.removeAttribute("tabindex");
    table.removeAttribute("role");
    table.removeAttribute("aria-label");
  }
}

class TableScroll {
  constructor() {
    this.tables = document.querySelectorAll(TABLE_SELECTOR);

    if (this.tables.length === 0) {
      return;
    }

    this.sync();
    window.addEventListener("resize", () => this.sync());
  }

  sync() {
    this.tables.forEach(syncTable);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new TableScroll();
});

export default TableScroll;
